import React from 'react';
export function Historia() {
  return <section id="historia" className="relative py-24 px-6 md:px-12 overflow-hidden" data-id="element-46">
      {/* Two background photos — Tupac left, Padre right */}
      <div className="absolute inset-0 z-0 grid grid-cols-1 grid-rows-2 md:grid-cols-2 md:grid-rows-1" data-id="element-47">
        <img src="https://cdn.magicpatterns.com/uploads/i541BLbmDqFu8iTD3VxYGq/FOTO_TUPAC_P2.jpg" alt="Tupac tejiendo en su taller" className="w-full h-full object-cover" data-id="element-48" />
        <img src="https://cdn.magicpatterns.com/uploads/1gFBydZ8eeeYEYLftYKvLE/PADRE_TUPAC_P2.png" alt="El padre de Tupac tejiendo en telar tradicional" className="w-full h-full object-cover" data-id="element-49" />
      </div>

      {/* Dark overlay for legibility */}
      <div className="absolute inset-0 z-10 bg-negro/40" aria-hidden="true" data-id="element-50"></div>

      {/* Text block floating on top */}
      <div className="relative z-20 max-w-3xl mx-auto flex flex-col items-center text-center gap-6 pt-32 md:pt-48 pb-12 md:pb-20" data-id="element-51">
        <h2 className="font-labrada font-bold text-3xl md:text-5xl text-crema leading-tight inline-block px-4 py-1.5 border border-crema/30 backdrop-blur-sm bg-negro/15 rounded-2xl -translate-y-[100px] md:translate-y-0" data-id="element-52">
          Lo que tejió mi abuelo, lo tejo yo
        </h2>
        <p className="font-labrada text-lg md:text-xl text-crema leading-relaxed inline-block px-4 py-2 border border-crema/30 backdrop-blur-sm bg-negro/15 rounded-2xl -translate-y-[100px] md:translate-y-0" data-id="element-53">
          Lloq'e nace de una tradición familiar de generaciones. Mi abuelo y mi
          padre fueron tejedores. Hoy mantengo ese oficio vivo en la Quebrada de
          Humahuaca con fibras 100% naturales de llama, oveja y vicuña, y tintes
          naturales de la región.
        </p>
      </div>
    </section>;
}